import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("img", { src: "/assets/icon/SettingIcon.svg" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_button = _resolveComponent("ion-button")!
  const _component_IonImg = _resolveComponent("IonImg")!
  const _component_ion_buttons = _resolveComponent("ion-buttons")!

  return (_openBlock(), _createBlock(_component_ion_buttons, { slot: "primary" }, {
    default: _withCtx(() => [
      _createVNode(_component_ion_button, {
        "data-cy": "userDialogButton-settings",
        onClick: _ctx.goToSettings
      }, {
        default: _withCtx(() => [
          _hoisted_1
        ]),
        _: 1
      }, 8, ["onClick"]),
      _createVNode(_component_ion_button, {
        "data-cy": "userDialogButton-popover",
        onClick: _cache[0] || (_cache[0] = (e) => _ctx.openPopover(e, 'user.profileImage'))
      }, {
        default: _withCtx(() => [
          _createVNode(_component_IonImg, {
            src: 
          _ctx.user?.profilbild
            ? _ctx.getPhotoUrl(_ctx.user.profilbild)
            : './assets/img/profiles/placeholder_profile_image.png'
        ,
            class: "rounded-full overflow-hidden",
            style: {"width":"32px","height":"32px","background":"white"}
          }, null, 8, ["src"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}